import axios from "axios";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { BASE_URL } from "../utils/constants";
import { removeUser } from "../utils/userSlice";

const Navbar = () => {
  const location = useLocation();

  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await axios.post(BASE_URL + "/logout", {}, { withCredentials: true });
      dispatch(removeUser());
      return navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const getLinkClasses = (path) =>
    location.pathname.startsWith(path)
      ? "text-pink-600 border-b-2 border-pink-600 pb-1"
      : "hover:text-pink-600";

  return (
    <div className="shadow-sm border-b">
      {/* Main Navbar */}
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex space-x-8 font-medium text-base">
          {user && (
            <>
              <Link
                to="/materialList"
                className={getLinkClasses("/materialList")}
              >
                Raw Material 
              </Link>
              <Link
                to="/formulation"
                className={getLinkClasses("/formulation")}
              >
                Formulation
              </Link>
            </>
          )}
        </div>

        {/* User Dropdown */}
        {user && (
          <div className="relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="font-semibold text-gray-700 hover:text-pink-600 focus:outline-none"
            >
              {user.firstName}
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-50">
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
